__turbopack_context__.v({
  "content": "index-module-scss-module__Ed2aVW__content",
  "radio-item": "index-module-scss-module__Ed2aVW__radio-item",
  "text": "index-module-scss-module__Ed2aVW__text",
  "top": "index-module-scss-module__Ed2aVW__top",
});
